
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'Counter',
  props: {
    counterState: {
      type: Object as PropType<{ title: string; count: number }>,
      required: true
    },
    increment: {
      type: Function,
      required: true
    },
    decrement: {
      type: Function,
      required: true
    },
    reset: {
      type: Function,
      required: true
    }
  }
})
